/**
 * PageTranslateBarV2 — full-width, high-contrast bar that houses the
 * unified TranslateWidget. Deliberately prominent (dark background, larger
 * label) because a huge share of our audience (India, Asia, Europe,
 * Middle East) benefits from an obvious way to read the page in their
 * native language.
 *
 * Also carries a second CTA on the right — "Grow Your Business with
 * Social Pulse" — pointing to the Business Portal.
 */
import { Link } from "react-router-dom";
import { Languages, ArrowRight, Building2 } from "lucide-react";
import TranslateWidget from "@/components/TranslateWidget";

export default function PageTranslateBarV2() {
  return (
    <div
      data-testid="page-translate-bar-v2"
      className="w-full border-b"
      style={{
        background: "linear-gradient(90deg, #1F2937 0%, #111827 55%, #1F2937 100%)",
        borderColor: "rgba(255,255,255,0.08)",
        color: "#FDFBF7",
      }}
    >
      <div className="max-w-[1400px] mx-auto flex flex-wrap items-center justify-between gap-3 px-4 sm:px-6 py-3">
        {/* LEFT — bold translate CTA + widget */}
        <div className="flex items-center gap-3 min-w-0 flex-wrap">
          <div className="inline-flex items-center gap-2">
            <Languages className="w-5 h-5" style={{ color: "#FDBA74" }} aria-hidden />
            <span
              className="font-display text-base sm:text-lg leading-tight"
              data-testid="translate-headline"
            >
              Read this page in your language
            </span>
          </div>
          <TranslateWidget className="translate-widget-dark" />
        </div>

        {/* RIGHT — Grow Your Business CTA */}
        <Link
          to="/businesses"
          data-testid="grow-business-cta"
          className="group inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors"
          style={{
            background: "#FDBA74",
            color: "#1F2937",
          }}
        >
          <Building2 className="w-4 h-4" aria-hidden />
          <span>Grow Your Business with Social Pulse</span>
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden />
        </Link>
      </div>
    </div>
  );
}
